var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTailwindcss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 9.604C18.411 9.604 14.653 12.043 12.724 16.922C12.524 17.427 13.141 17.842 13.54 17.473C15.575 15.591 17.862 14.968 20.4 15.602C22.226 16.058 23.531 17.383 24.976 18.849C27.328 21.236 30.051 24 36 24C41.589 24 45.348 21.56 47.276 16.681C47.476 16.176 46.859 15.761 46.46 16.13C44.425 18.012 42.138 18.636 39.6 18.002C37.775 17.546 36.47 16.221 35.025 14.755C32.672 12.367 29.948 9.604 24 9.604ZM12 24C6.411 24 2.652 26.44 0.724 31.319C0.524 31.824 1.141 32.239 1.54 31.87C3.575 29.988 5.862 29.364 8.4 29.999C10.225 30.456 11.53 31.78 12.975 33.245C15.328 35.633 18.052 38.397 24 38.397C29.589 38.397 33.348 35.957 35.276 31.078C35.476 30.573 34.859 30.158 34.46 30.527C32.425 32.409 30.138 33.033 27.6 32.398C25.774 31.942 24.469 30.617 23.024 29.152C20.672 26.764 17.949 24 12 24Z",
    fill: "url(#paint0_linear_398_25)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_398_25",
    x1: 21.861,
    y1: 8.237,
    x2: 25.703,
    y2: 36.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BB8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwindcss);
export default __webpack_public_path__ + "static/media/tailwindcss.6e8e85fcd63cfd3e6ab686ae1ef6f636.svg";
export { ForwardRef as ReactComponent };